<template>
  <ElSelect
    v-model="organization"
    allow-create
    filterable
    remote
    clearable
    placeholder="Type company name"
    :remote-method="searchOrganizations"
    :loading="loading"
    autocomplete="nope"
    @change="handleOrganizationChange"
  >
    <ElOption
      v-for="item in data"
      :key="item.id"
      :label="item.name"
      :value="item"
    />
  </ElSelect>
</template>

<script>
import axios from '@/axios/axios'
import debounce from 'debounce-promise'

export default {
  name: 'Organization',
  props: {
    // eslint-disable-next-line vue/no-unused-properties
    value: {
      type: String,
      default: ''
    },
    selected: {
      type: Object,
      default: () => {}
    },
    vuelidate: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      organization: '',
      loading: false,
      data: []
    }
  },
  created() {
    if (this.selected) this.handleOrganizationChange(this.selected, true)
  },
  methods: {
    searchOrganizations(search) {
      this.loading = true
      this.getOrganizationsDebounce(search, this)
    },

    getOrganizationsDebounce: debounce((search, vm) => {
      vm.getOrganizations(search)
        .then(res => {
          vm.data = res.data.content
          vm.loading = false
        })
    }, 400),

    handleOrganizationChange(value, init) {
      if (typeof value === 'object') {
        this.$emit('update:selected', value)
        this.$emit('update:value', value.name)
        this.organization = value.name
      }
      else {
        this.$emit('update:selected', {})
        this.$emit('update:value', value)
        this.organization = value
      }

      if (!init) {
        this.vuelidate()
      }
    },

    // eslint-disable-next-line vue/no-unused-properties
    getOrganizations(name) {
      return axios.get('organizations/query', {
        params: {
          queryName: name,
          page: '0',
          size: '5'
        }
      })
    },

    // eslint-disable-next-line vue/no-unused-properties
    validateOrCreateOrganization() {
      if (this.selected && this.selected.id) {
        return Promise.resolve(true)
      }

      const name = this.organization
      return this.createOrganization(name)
    },

    createOrganization(name) {
      const data = {
        name
      }

      return axios.post('organizations', data)
        .then(res => {
          this.$emit('update:selected', res.data)
          this.$emit('update:value', res.data.name)
          this.organization = res.data.name
        })
    }
  }
}
</script>
